// External dependencies.
import $ from "jquery";

/**
 * Cart class.
 *
 * @since 0.15.0
 * @class Cart
 */
class Cart {
    /**
     * Creates an instance of Cart.
     * 
     * @since 0.15.0
     * @memberof Cart
     */
    constructor() {
        this.events = this.events.bind(this);
        this.events();
    }

    /**
     * Listens for events.
     *
     * @since 0.15.0
     * @listens event:updated_wc_div
     * @memberof Cart
     */
    events() {
        $(document).on('updated_wc_div', this.getCartContentsCount);

        jQuery(".cross-sells .slider-container")?.slick({
            dots: true,
            infinite: true,
            speed: 300,
            autoplay: true,
            autoplaySpeed: 3000,
            slidesToShow: 3,
            slidesToScroll: 3,
            responsive: [
                {
                    breakpoint: 1400,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 1200,
                    settings: {
                        slidesToShow: 2,
                        slidesToScroll: 2,
                        infinite: true,
                        dots: true
                    }
                },
                {
                    breakpoint: 480,
                    settings: {
                        slidesToShow: 1,
                        slidesToScroll: 1,
                        infinite: true,
                        dots: true
                    }
                }
                // You can unslick at a given breakpoint now by adding:
                // settings: "unslick"
                // instead of a settings object
            ]
        });
    }

    /**
     * Gets the cart contents count and updates the header with the count.
     *
     * @since 0.15.0
     * @memberof Cart
     */
    getCartContentsCount() {
        const header = document.querySelector('app-header');
        const url = new URL(window.app.ajax_url);
        url.search = new URLSearchParams({ action: 'get_cart_contents_count' });

        fetch(url.href)
            .then(res => res.json())
            .then(res => {
                header.cartContentsCount = res;
            })
            .catch(err => {
                console.log(err);
                header.cartContentsCount = '0';
            });
    }
}

export default Cart;
